import Papa from "papaparse";
import {DayReport} from "@/data/entities/dayReport";
import {RestaurantLocation} from "@/data/entities/restaurant";
import {
    DayReportSummaryColumn,
    dayReportSummaryColumns
} from "@widgets/reports/dayReport/summary/DayReportSummaryColumns";
import {reportPeriod} from "@widgets/reports/dayReport/DayReportUtils";
import {formatPeriod} from "@widgets/reports/dayReport/period/ReportPeriod";

/**
 * Downloads the day report as a CSV file: the same columns as the summary
 * table on the page.
 */
export const exportDayReportCsv = (dayReport: DayReport, location: RestaurantLocation) => {
    const row: Record<string, string | number> = Object.fromEntries(
        dayReportSummaryColumns.map((column: DayReportSummaryColumn) => [column.header, column.csvValue(dayReport)]),
    );
    const csv: string = Papa.unparse([row]);

    // BOM, so Excel reads the file as UTF-8
    const blob = new Blob(["\ufeff" + csv], {type: "text/csv;charset=utf-8;"});
    const url: string = URL.createObjectURL(blob);
    const link: HTMLAnchorElement = document.createElement("a");
    link.href = url;
    link.download = `Rapport ${location.name} ${formatPeriod(reportPeriod(dayReport))}.csv`;
    link.click();
    URL.revokeObjectURL(url);
};